import { dateSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const updateExpirySchema = object().shape({
    date_of_expiry: dateSchema,
});

export default updateExpirySchema;